import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import imagingServicesdata from "../../data/imagingServicesdata";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper/modules";
import VerifiedIcon from "@mui/icons-material/Verified";
import Faqs from "../Faqs";
import { useLenis } from "../SmoothScroll";
export default function SingleServicePage() {
  const { slug } = useParams();
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);

  const service = imagingServicesdata.find((s) => s.slug === slug);
  if (!service) return <p className="text-white">Service not found</p>;

  return (
    <div>
      <div className="text-black font-sans">
        {/* Hero Section */}
        <div className="relative bg-white md:pt-96 pt-72 pb-52 px-4 sm:px-8">
          {/* Foreground Content */}
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start relative ">
            {/* Left Side */}
            <div>
              <h1
                data-aos="fade-right"
                className=" pe-8 md:pe-16 text-3xl md:text-[3rem] lg:text-[3.5rem] xl:text-[5rem] font-normal md:leading-[1] font-Matter"
              >
                {service.subTitle}
              </h1>
              <h2
                data-aos="fade-right"
                data-aos-delay="100"
                className=" text-4xl md:text-[2.75rem] md:leading-[.81818] font-bold text-[#cfa751] md:mt-[4.125rem] mt-12 font-Antique"
              >
                {service.title}
              </h2>
            </div>
          </div>
        </div>
        {/* Full Width Image */}
        <div className="relative -mt-24">
          <img
            src={service.shapedImg}
            alt={service.alt}
            className="w-full h-auto object-cover"
          />
        </div>
      </div>

      {/* What is ......... ?  */}

      <div data-aos="fade-up" className="flex justify-center items-center">
        <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 2xl:py-[22rem] xl:py-[12rem] py-[6rem] xl:px-16 2xl:px-0 text-white">
          <div className="2xl:text-[48px] xl:text-5xl text-4xl text-left  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
            <h3 className="text-[#cfa751]">{service?.whatIs?.heading}</h3>
          </div>
          <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  text-left ">
            {service.whatIs?.text
              .trim()
              .split(".")
              .filter((sentence) => sentence.trim().length > 0) // remove blanks
              .map((item, index) => (
                <p className="my-2" key={index}>
                  {item.trim()}.
                </p>
              ))}
          </div>
        </div>
      </div>

      {/* Video If available  */}
      {service?.whatIs?.video && (
        <div className="flex justify-center items-center">
          <div className="2xl:w-4/5 w-[90%]">
            <video
              autoPlay
              muted
              loop
              width="100%"
              className="rounded-3xl h-4/6"
              playsInline
            >
              <source src={service?.whatIs?.video} type="video/mp4" />
            </video>
          </div>
        </div>
      )}

      {/* How Works ....  */}

      <div data-aos="fade-up" className="flex justify-center items-center">
        <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 2xl:py-[22rem] xl:py-[12rem] py-[6rem] xl:px-16 2xl:px-0 text-white">
          <div className="2xl:text-[48px] xl:text-5xl text-4xl lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
            <h3 className="text-[#cfa751]">{service?.howWork?.heading}</h3>
          </div>
          <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  lg:text-left text-center">
            {service?.howWork?.text &&
              service?.howWork?.text.trim() &&
              service?.howWork?.text.split("\n\n").map((para, i) => (
                <p key={i} className="mb-4">
                  {para}
                </p>
              ))}
            {service?.howWork?.points && (
              <ul className=" text-left mt-4 pl-5 ">
                {service?.howWork?.points.map((point, i) => (
                  <li key={i} className="mb-2 flex flex-row gap-4">
                    <span className="flex-shrink-0 text-2xl text-[#cfa751]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* Video If available  */}
      {service?.howWork?.video && (
        <div className="flex justify-center items-center">
          <div className="2xl:w-4/5 w-[90%]">
            <video
              autoPlay
              muted
              loop
              width="100%"
              className="rounded-3xl h-4/6"
              playsInline
            >
              <source src={service?.howWork?.video} type="video/mp4" />
            </video>
          </div>
        </div>
      )}

      {/* Significant of the service  */}
      {service?.significant && (
        <div data-aos="fade-up" className="flex justify-center items-center">
          <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 2xl:py-[22rem] xl:py-[12rem] py-[6rem] xl:px-16 2xl:px-0 text-white">
            <div className="2xl:text-[48px] xl:text-5xl text-4xl lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
              <h3 className="text-[#cfa751]">
                {service?.significant?.heading}
              </h3>
            </div>
            <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  lg:text-left text-center">
              {service?.significant?.points && (
                <ul className=" text-left mt-4 pl-5 ">
                  {service?.significant?.points.map((point, i) => (
                    <li key={i} className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#cfa751]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Conditinos A ... can detect  */}

      <div
        data-aos="fade-up"
        className="flex justify-center items-center py-14 md:py-20 lg:py-24 xl:py-28 2xl:py-32"
      >
        <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 md:py-32 py-16  xl:px-16 2xl:px-0 text-white">
          <div className="2xl:text-[48px] xl:text-5xl text-4xl lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
            <h3 className="text-[#cfa751]">{service?.conditions?.heading}</h3>
          </div>
          <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  lg:text-left text-center">
            <p className="mb-4">{service?.conditions?.text}</p>
            {service?.conditions?.points && (
              <ul className=" text-left mt-4 pl-5 ">
                {service?.conditions?.points.map((point, i) => (
                  <li key={i} className="mb-2 flex flex-row gap-4">
                    <span className="flex-shrink-0 text-2xl text-[#cfa751]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* Common use case for ..... */}

      {service?.usecase && (
        <div
          data-aos="fade-up"
          className="flex justify-center items-center py-14 md:py-20 lg:py-24 xl:py-28 2xl:py-32"
        >
          <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2  xl:px-16 2xl:px-0 text-white">
            <div className="2xl:text-[48px] xl:text-5xl text-4xl lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
              <h3 className="text-[#cfa751]">{service?.usecase?.heading}</h3>
            </div>
            <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  lg:text-left text-center">
              <p className="mb-4">{service?.usecase?.text}</p>
              {service?.usecase?.points && (
                <ul className=" text-left mt-4 pl-5 ">
                  {service?.usecase?.points.map((point, i) => (
                    <li key={i} className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#a374ff]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Top benefits of service ....  */}

      <div
        data-aos="fade-up"
        className="flex justify-center items-center py-14 md:py-20 lg:py-24 xl:py-28 2xl:py-32"
      >
        <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2  xl:px-16 2xl:px-0 text-white">
          <div className="2xl:text-[48px] xl:text-5xl text-4xl lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
            <h3 className="text-[#cfa751]">{service?.benefits?.heading}</h3>
          </div>
          <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  lg:text-left text-center">
            {service?.benefits?.points && (
              <ul className=" text-left mt-4 pl-5 ">
                {service?.benefits?.points.map((point, i) => (
                  <li key={i} className="mb-2 flex flex-row gap-4">
                    <span className="flex-shrink-0 text-2xl text-[#17f1d1]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* Types of ..... service  */}

      {service.typerof && (
        <div
          data-aos="fade-up"
          className="flex justify-center flex-col items-center py-14 md:py-20 lg:py-24 xl:py-28 2xl:py-32"
        >
          <div className="2xl:text-[48px] xl:text-5xl text-4xl text-white lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
            <h3 className="text-[#cfa751]">Types of {service?.title}</h3>
          </div>
          <div className="px-4 pb-8 pt-16 sm:px-6 sm:pt-10 md:px-8 md:pt-12 lg:px-10 flex xl:w-3/4 w-11/12  slider-wrapper overflow-hidden justify-center relative items-center flex-col lg:pt-16">
            <Swiper
              loop={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              grabCursor={true}
              spaceBetween={50}
              navigation={{
                nextEl: ".next-button",
                prevEl: ".prev-button",
              }}
              modules={[Navigation]}
              className="custom-swiper flex justify-center text-white items-baseline mt-12 "
            >
              {service.typerof.map((index) => (
                <SwiperSlide
                  key={index}
                  className="slide-card flex justify-center mt:py-10 pt-0 lg:py-16 relative "
                >
                  <div className=" xl:w-4/5 2xl:w-3/4 w-full  ">
                    <div className="flex flex-col justify-center lg:gap-2  gap-1 items-start overflow-y-auto p-8">
                      <h3 className="2xl:text-[48px] xl:text-5xl text-4xl py-8 font-Antique text-[#cfa751]  w-full capitalize text-center font-medium">
                        {index.heading}
                      </h3>

                      <p className=" xl:text-2xl md:text-xl sm:text-lg text-lg md:text-left text-center">
                        {index.text}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="nav-container absolute w-full hidden  h-full md:flex justify-between items-center">
              <button className="group  nav-button prev-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
                <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="block group-hover:opacity-0  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                  <span className="absolute   top-0 left-0  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                </span>
              </button>
              <button className="group  nav-button next-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
                <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="block group-hover:opacity-0 rotate-180  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                  <span className="absolute   top-0 left-0  opacity-0 rotate-180 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                </span>
              </button>
            </div>
            <div className="nav-container  w-full flex  h-full  md:hidden justify-center items-center">
              <button className="group  nav-button prev-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
                <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="block group-hover:opacity-0  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                  <span className="absolute   top-0 left-0  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                </span>
              </button>
              <button className="group  nav-button next-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
                <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="block group-hover:opacity-0 rotate-180  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                  <span className="absolute   top-0 left-0  opacity-0 rotate-180 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <KeyboardBackspaceIcon />
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Post Expectations after using the service  */}
      <div
        data-aos="fade-up"
        className="flex justify-center items-center py-14 md:py-20 lg:py-24 xl:py-28 2xl:py-32"
      >
        <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2  xl:px-16 2xl:px-0 text-white">
          <div className="2xl:text-[48px] xl:text-5xl text-4xl lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
            <h3 className="text-[#cfa751]">
              {service?.postexpectation?.heading}
            </h3>
          </div>
          <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  lg:text-left text-center">
            <p className="mb-4">{service?.postexpectation?.text}</p>{" "}
            {service?.postexpectation?.points && (
              <ul className=" text-left mt-4 pl-5 ">
                {service?.postexpectation?.points.map((point, i) => (
                  <li key={i} className="mb-2 flex flex-row gap-4">
                    <span className="flex-shrink-0 text-2xl text-[#17f1d1]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* How safe is this service?  */}
      {service.howsafe && (
        <div
          data-aos="fade-up"
          className="flex justify-center py-14 md:py-20 lg:py-24 xl:py-28 2xl:py-32 items-center"
        >
          <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 xl:px-16 2xl:px-0 text-white">
            <div className="2xl:text-[48px] xl:text-5xl text-4xl lg:text-left text-center  font-Matter font-bold pb-4 lg:pb-0 lg:w-[70%]">
              <h3 className="text-[#cfa751]">{service?.howsafe?.heading}</h3>
            </div>
            <div className="xl:text-2xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4  lg:text-left text-center">
              <p className="mb-4">{service?.howsafe?.text}</p>{" "}
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center py-14 md:py-20 lg:py-24 xl:py-28 2xl:py-32 items-center">
        <div className="2xl:w-4/5 w-[90%] xl:px-16 2xl:px-0 text-white">
          <Faqs faqs={service?.faqs} />
        </div>
      </div>
    </div>
  );
}
